
(function () {
  'use strict';
  function money(cents) {
    var v = cents / 100;
    try { return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
    catch (e) { return '₹' + v; }
  }
  function init(root) {
    var dataEl = root.querySelector('[data-sf-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = root.querySelector('form');
    var select = root.querySelector('[data-sf-variant-select]');
    var priceEl = root.querySelector('[data-sf-price]');
    var statusEl = root.querySelector('[data-sf-status]');
    var errorEl = root.querySelector('[data-sf-error]');
    var addBtn = root.querySelector('[data-sf-add]');
    var buy = root.querySelector('[data-sf-buy]');
    var quoteLink = root.querySelector('[data-sf-quote-link]');
    var coverSelect = root.querySelector('[data-sf-cover]');
    var priceHelp = root.querySelector('[data-sf-price-help]');
    var originalPriceHelp = priceHelp ? priceHelp.textContent : '';
    var plateSelect = root.querySelector('[data-sf-plate]');
    var coverLabels = data.coverLabels || {};
    var quoteLabel = root.querySelector('[data-sf-quote-label]');
    var originalQuoteLabel = quoteLabel ? quoteLabel.textContent : '';
    [coverSelect, plateSelect].forEach(function (control) {
      if (control) Array.prototype.forEach.call(control.querySelectorAll('option'), function (option) { option.disabled = false; });
    });
    function coverNeedsQuote() {
      return Boolean((coverSelect && coverSelect.value !== 'Printed photo cover') || (plateSelect && plateSelect.value !== 'No plate'));
    }
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sf-group]'));
    var split = data.splitIndex;
    var names = data.optionNames || [];

    var labels = data.galleryLabels || {};
    var initialId = String(data.initialVariantId || (select && select.value) || '');
    if (select && Array.isArray(data.variants)) {
      select.replaceChildren();
      data.variants.forEach(function (v) {
        var option = document.createElement('option');
        option.value = String(v.id);
        option.textContent = (v.title || v.options.join(' / ')) + ' — ' + money(v.price);
        option.selected = String(v.id) === initialId;
        select.appendChild(option);
      });
      if (initialId) select.value = initialId;
    }
    function imageKey(src) {
      if (!src) return '';
      try { return new URL(String(src), window.location.href).pathname; }
      catch (e) { return String(src).split('?')[0]; }
    }
    function imageUrl(src, width) {
      try { var url = new URL(src, window.location.href); url.searchParams.set('width', width); return url.href; }
      catch (e) { return src; }
    }
    function variantImageKey(v) {
      if (!v) return '';
      var image = v.featured_image || v.featured_media || v.image;
      if (!image) return '';
      if (typeof image === 'string') return imageKey(image);
      var preview = image.preview_image || image;
      return imageKey(preview.src || preview.url || '');
    }
    var media = (data.media || []).map(function (item) {
      if (typeof item === 'string') return { src: item, alt: data.title || '' };
      var preview = item.preview_image || item;
      return { src: preview.src || preview.url || '', alt: item.alt || preview.alt || data.title || '', width: preview.width, height: preview.height };
    }).filter(function (item) { return Boolean(item.src); });
    var assignedImages = new Set((data.variants || []).map(variantImageKey).filter(Boolean));
    var gallery = root.querySelector('[data-sf-gallery]');
    var stage = root.querySelector('[data-sf-stage]');
    var thumbBar = root.querySelector('.sf-thumbs');
    var galleryNote = root.querySelector('[data-sf-gallery-note]');
    var gallerySelection = root.querySelector('[data-sf-gallery-selection]');
    var originalNote = galleryNote ? galleryNote.textContent : '';
    var zoom = root.querySelector('[data-sf-zoom]');
    var lb = root.querySelector('[data-sf-lightbox]');
    var firstVariant = (data.variants || []).filter(function (v) { return String(v.id) === initialId; })[0];
    var initialKey = variantImageKey(firstVariant);
    function makeImage(item, width, eager) {
      var image = document.createElement('img');
      image.src = imageUrl(item.src, width);
      image.alt = item.alt;
      image.loading = eager ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.fetchPriority = eager ? 'high' : 'auto';
      if (item.width && item.height) { image.width = item.width; image.height = item.height; }
      if (width > 160) {
        image.srcset = [320, 640, 960, 1200, 1600].map(function (size) { return imageUrl(item.src, size) + ' ' + size + 'w'; }).join(', ');
        image.sizes = '(min-width: 990px) 52vw, 100vw';
      }
      return image;
    }
    if (gallery && stage && media.length) {
      var serverSlide = stage.querySelector('[data-sf-slide]');
      var serverImage = serverSlide && serverSlide.querySelector('img');
      var serverKey = serverImage ? imageKey(serverImage.getAttribute('src')) : '';
      var reusedServerSlide = false;
      if (!thumbBar) { thumbBar = document.createElement('div'); thumbBar.className = 'sf-thumbs'; thumbBar.setAttribute('role', 'list'); gallery.insertBefore(thumbBar, stage); }
      thumbBar.replaceChildren();
      media.forEach(function (item, i) {
        var key = imageKey(item.src);
        var eligible = !assignedImages.has(key) || key === initialKey;
        var useServerSlide = serverKey && serverKey === key && !reusedServerSlide;
        var slide = useServerSlide ? serverSlide : document.createElement('div');
        if (useServerSlide) reusedServerSlide = true;
        slide.setAttribute('data-sf-slide', i);
        slide.style.position = 'absolute';
        slide.style.inset = '0';
        slide.hidden = Boolean(key !== initialKey && (initialKey || i !== 0));
        if (!useServerSlide) slide.appendChild(makeImage(item, 1200, key === initialKey || (!initialKey && i === 0)));
        stage.insertBefore(slide, zoom || null);
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'sf-thumb';
        thumb.setAttribute('role', 'listitem');
        thumb.setAttribute('data-sf-thumb', i);
        thumb.hidden = !eligible;
        var thumbImage = makeImage(item, 160, false);
        thumbImage.alt = '';
        thumb.appendChild(thumbImage);
        thumbBar.appendChild(thumb);
      });
    }
    if (serverSlide && !reusedServerSlide) serverSlide.remove();
    data.media = media.map(function (item) { return imageUrl(item.src, 1600); });
    var slides = root.querySelectorAll('[data-sf-slide]');
    var thumbs = root.querySelectorAll('[data-sf-thumb]');
    var visible = [];
    var current = -1;
    function show(i) {
      if (visible.indexOf(i) < 0) return;
      current = i;
      Array.prototype.forEach.call(slides, function (slide, index) { slide.hidden = index !== i; });
      Array.prototype.forEach.call(thumbs, function (thumb, index) {
        if (index === i) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      if (lb && lb.open) lb.querySelector('[data-sf-lightbox-img]').src = data.media[i];
    }
    function updateGallery(v) {
      var selectedKey = variantImageKey(v);
      var selectedIndex = media.findIndex(function (item) { return imageKey(item.src) === selectedKey; });
      var missing = assignedImages.size > 0 && selectedIndex < 0;
      visible = [];
      media.forEach(function (item, index) {
        var key = imageKey(item.src);
        if (!missing && (!assignedImages.has(key) || key === selectedKey)) visible.push(index);
      });
      Array.prototype.forEach.call(thumbs, function (thumb, index) {
        var rank = visible.indexOf(index);
        thumb.hidden = rank < 0;
        thumb.setAttribute('aria-label', (labels.show || 'Show image __index__ of __total__').replace('__index__', rank + 1).replace('__total__', visible.length));
      });
      if (gallery) gallery.classList.toggle('sf-gallery--single', visible.length < 2);
      if (galleryNote) galleryNote.textContent = missing ? (labels.missing || 'Photo for this combination is being prepared.') : originalNote;
      if (gallerySelection) {
        gallerySelection.hidden = !v || !v.options || (v.options.length === 1 && v.options[0] === 'Default Title');
        gallerySelection.textContent = v && v.options ? (labels.selected || 'Selected configuration') + ': ' + v.options.join(' · ') : '';
      }
      if (zoom) zoom.hidden = !visible.length || !lb || typeof lb.showModal !== 'function';
      if (visible.length) show(selectedIndex >= 0 ? selectedIndex : visible[0]);
      else {
        current = -1;
        Array.prototype.forEach.call(slides, function (slide) { slide.hidden = true; });
        if (lb && lb.open && typeof lb.close === 'function') lb.close();
      }
    }
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () { show(parseInt(thumb.getAttribute('data-sf-thumb'), 10)); });
    });
    if (lb && zoom && typeof lb.showModal === 'function') {
      zoom.addEventListener('click', function () {
        if (current < 0 || !data.media[current]) return;
        lb.querySelector('[data-sf-lightbox-img]').src = data.media[current];
        lb.showModal();
      });
      lb.querySelector('[data-sf-lightbox-close]').addEventListener('click', function () { lb.close(); zoom.focus(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    } else if (zoom) zoom.hidden = true;

    
    function checkedValue(group) {
      var el = group.querySelector('input:checked');
      return el ? el.value : null;
    }
    function selection() {
      var sel = [];
      for (var i = 0; i < names.length; i++) sel.push(null);
      var orient = null, size = null;
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-opt-index'), 10);
        var kind = g.getAttribute('data-sf-group');
        var v = checkedValue(g);
        if (kind === 'orient') orient = v;
        else if (kind === 'size') size = v;
        else sel[idx] = v;
      });
      if (split >= 0 && orient && size) sel[split] = size + ' ' + orient;
      return sel;
    }
    function matches(variant, sel) {
      for (var i = 0; i < sel.length; i++) { if (sel[i] !== null && variant.options[i] !== sel[i]) return false; }
      return true;
    }
    function findVariant(sel) {
      for (var i = 0; i < data.variants.length; i++) if (matches(data.variants[i], sel)) return data.variants[i];
      return null;
    }
    function anyVariant(sel, availableOnly) {
      return data.variants.some(function (v) { return matches(v, sel) && (!availableOnly || v.available); });
    }

    
    function refreshAvailability() {
      var sel = selection();
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-opt-index'), 10);
        var kind = g.getAttribute('data-sf-group');
        Array.prototype.forEach.call(g.querySelectorAll('input[type=radio]'), function (input) {
          var test = sel.slice();
          if (kind === 'orient') {
            var size = checkedValue(groups.filter(function (x) { return x.getAttribute('data-sf-group') === 'size'; })[0]);
            test[split] = size ? size + ' ' + input.value : null;
            input.disabled = false; 
            return;
          }
          if (kind === 'size') {
            var o = checkedValue(groups.filter(function (x) { return x.getAttribute('data-sf-group') === 'orient'; })[0]);
            test[split] = input.value + ' ' + o;
          } else { test[idx] = input.value; }
          input.disabled = !anyVariant(test, false);
        });
      });
    }
    function applyOrientation() {
      var og = groups.filter(function (x) { return x.getAttribute('data-sf-group') === 'orient'; })[0];
      var sg = groups.filter(function (x) { return x.getAttribute('data-sf-group') === 'size'; })[0];
      if (!og || !sg) return;
      var o = checkedValue(og);
      var firstVisible = null, hasChecked = false;
      Array.prototype.forEach.call(sg.querySelectorAll('.sf-pill'), function (pill) {
        var match = pill.getAttribute('data-orient') === o;
        pill.hidden = !match;
        var inp = pill.querySelector('input');
        if (match && !firstVisible) firstVisible = inp;
        if (match && inp.checked) hasChecked = true;
        if (!match) inp.checked = false;
      });
      if (!hasChecked && firstVisible) firstVisible.checked = true;
    }

    var sizeGuide = root.querySelector('[data-sf-size-guide]');
    var sizeChart = root.querySelector('[data-sf-size-chart]');
    var sizeIndex = names.findIndex(function (name) { return /size/i.test(name); });
    var sizeOptions = [];
    if (sizeIndex >= 0) (data.variants || []).forEach(function (variant) {
      var value = variant.options[sizeIndex];
      var match = value && value.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      if (match && !sizeOptions.some(function (item) { return item.w === Number(match[1]) && item.h === Number(match[2]); })) sizeOptions.push({ w: Number(match[1]), h: Number(match[2]) });
    });
    function updateSizeChart(variant) {
      if (!sizeChart || !sizeGuide || sizeOptions.length < 2) return;
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      var rows = [];
      for (var i = 0; i < sizeOptions.length; i += 3) rows.push(sizeOptions.slice(i, i + 3));
      var scale = Math.min(26, 1050 / Math.max.apply(null, rows.map(function (row) { return row.reduce(function (sum, item) { return sum + item.w; }, 0); })));
      var rowHeight = Math.max.apply(null, sizeOptions.map(function (item) { return item.h; })) * scale + 110;
      svg.setAttribute('viewBox', '0 0 1200 ' + (rows.length * rowHeight + 20));
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', coverLabels.sizes || 'Compare all sizes');
      function shape(tag, attributes, text) {
        var node = document.createElementNS('http://www.w3.org/2000/svg', tag);
        Object.keys(attributes).forEach(function (key) { node.setAttribute(key, attributes[key]); });
        if (text) node.textContent = text;
        svg.appendChild(node);
        return node;
      }
      var selected = variant && variant.options[sizeIndex];
      rows.forEach(function (row, rowIndex) {
        var total = row.reduce(function (sum, item) { return sum + item.w * scale; }, 0) + (row.length - 1) * 50;
        var x = (1200 - total) / 2;
        var baseline = rowIndex * rowHeight + rowHeight - 65;
        row.forEach(function (item) {
          var width = item.w * scale, height = item.h * scale;
          var match = selected && selected.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
          var active = Boolean(match && Number(match[1]) === item.w && Number(match[2]) === item.h);
          shape('rect', { x: x, y: baseline - height, width: width, height: height, rx: 3, fill: active ? '#eee1cd' : '#fbf8f2', stroke: active ? '#4c3428' : '#bcae9b', 'stroke-width': active ? 6 : 3 });
          shape('line', { x1: x + 12, x2: x + 12, y1: baseline - height + 3, y2: baseline - 3, stroke: '#bcae9b', 'stroke-width': 2 });
          shape('text', { x: x + width / 2, y: baseline + 45, 'text-anchor': 'middle', 'font-family': 'sans-serif', 'font-size': 36, fill: '#4c3428' }, item.w + ' × ' + item.h + ' in');
          x += width + 50;
        });
      });
      sizeChart.replaceChildren(svg);
      sizeGuide.hidden = false;
    }

    function update(userChanged) {
      applyOrientation();
      refreshAvailability();
      var v = findVariant(selection());
      var customCover = coverNeedsQuote();
      if (buy) buy.hidden = data.isQuote || customCover;
      if (quoteLink) {
        var primaryQuote = data.isQuote || customCover;
        quoteLink.classList.toggle('sf-btn', primaryQuote);
        quoteLink.classList.toggle('sf-btn--block', primaryQuote);
        quoteLink.classList.toggle('sf-link', !primaryQuote);
        if (quoteLabel) quoteLabel.textContent = customCover ? (coverLabels.quote || 'Get a quote for this cover') : originalQuoteLabel;
      }
      updateSizeChart(v);
      if (errorEl) errorEl.hidden = true;
      if (!v) {
        
        if (priceEl) priceEl.textContent = data.isQuote ? 'Request a quote' : 'Choose options';
        if (statusEl) { statusEl.hidden = false; statusEl.textContent = 'That combination is not available. Please change one option.'; }
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        updateGallery(null);
        updateQuoteLink(null);
        return;
      }
      if (select) select.value = String(v.id);
      if (priceEl) priceEl.textContent = data.isQuote ? 'Request a quote' : (customCover ? (coverLabels.base || 'Base book') + ': ' : '') + money(v.price);
      if (priceHelp) priceHelp.textContent = customCover ? (coverLabels.priceHelp || 'Request a quote for the total including your cover and plate.') : originalPriceHelp;
      if (addBtn) { addBtn.disabled = customCover || !v.available; addBtn.textContent = v.available ? 'Add to bag' : 'Unavailable'; }
      if (statusEl) {
        if (!v.available && !data.isQuote) { statusEl.hidden = false; statusEl.textContent = 'This combination is currently unavailable. Request a quote and we will help.'; }
        else statusEl.hidden = true;
      }
      if (userChanged && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      updateGallery(v);
      updateQuoteLink(v);
    }

    function propText(name) {
      var el = form.elements[name];
      return el && el.value ? String(el.value).replace(/\s+/g, ' ').trim() : '';
    }
    function updateQuoteLink(v) {
      if (!quoteLink) return;
      var parts = [];
      var sel = selection();
      for (var i = 0; i < names.length; i++) {
        if (sel[i] && names[i] !== 'Title') parts.push(names[i].replace('FInish', 'Finish') + ': ' + sel[i]);
      }
      var cover = propText('properties[Cover]'); if (cover) parts.push('Cover: ' + cover);
      var plate = propText('properties[Nameplate]'); if (plate && plate !== 'No plate') parts.push('Nameplate: ' + plate);
      var title = propText('properties[Cover title]'); if (title) parts.push('Cover title: ' + title);
      var box = propText('properties[Presentation box]'); if (box && box !== 'Not sure') parts.push('Box: ' + box);
      var colour = propText('properties[Colour preference]'); if (colour) parts.push('Colour: ' + colour);
      var qty = form.elements.quantity ? parseInt(form.elements.quantity.value, 10) : 0;
      if (qty > 1) parts.push('Copies: ' + qty);
      var base = quoteLink.getAttribute('data-base') || quoteLink.getAttribute('href');
      var cfg = parts.join('; ').slice(0, 380);
      quoteLink.setAttribute('href', cfg ? base + (base.indexOf('?') === -1 ? '?' : '&') + 'config=' + encodeURIComponent(cfg) : base);
    }

    groups.forEach(function (g) {
      g.addEventListener('change', function () { update(true); });
    });
    [coverSelect, plateSelect].forEach(function (control) { if (control) control.addEventListener('change', function () { update(false); }); });
    ['properties[Cover title]', 'properties[Colour preference]'].forEach(function (n) {
      var el = form.elements[n]; if (el) el.addEventListener('input', function () { updateQuoteLink(findVariant(selection())); });
    });
    Array.prototype.forEach.call(form.querySelectorAll('input[name="properties[Presentation box]"]'), function (r) {
      r.addEventListener('change', function () { updateQuoteLink(findVariant(selection())); });
    });

    
    var qty = root.querySelector('[data-sf-qty]');
    var minus = root.querySelector('[data-sf-qty-minus]');
    var plus = root.querySelector('[data-sf-qty-plus]');
    function setQty(n) { if (qty) { qty.value = Math.max(1, Math.min(99, n || 1)); updateQuoteLink(findVariant(selection())); } }
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(qty.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(qty.value, 10) + 1); });
    if (qty) qty.addEventListener('change', function () { setQty(parseInt(qty.value, 10)); });

    
    form.addEventListener('submit', function (e) {
      var v = findVariant(selection());
      if (coverNeedsQuote() || data.isQuote || !v || !v.available) {
        e.preventDefault();
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = coverNeedsQuote() ? (coverLabels.required || 'Please request a quote for your selected cover and plate.') : 'Please choose an available combination, or request a quote.'; }
      }
    });

    update(false);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sf-product]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

